import { useEffect, useState } from 'react';

const fullscreenClassnameExists = (target: Element | null): boolean =>
	target?.classList.contains('fullscreen') ?? false;

/**
 * @deprecated For Nav4 experiences use `useIsFullscreen` from `@atlassian/jira-layout-controller` instead.
 */
export const useIsFullscreen = (target: Element | null) => {
	const [isFullscreen, setIsFullscreen] = useState(false);

	useEffect(() => {
		const handleFullscreen = () => {
			setIsFullscreen(fullscreenClassnameExists(target));
		};

		const mutationObserver = new MutationObserver(handleFullscreen);
		if (target) {
			mutationObserver.observe(target, { attributes: true });
		}

		return () => mutationObserver.disconnect();
	}, [target]);

	return { isFullscreen };
};
